// ตัวกรอง "พนักงาน" แบบ Dropdown ที่ผูกกับแผนก (ลงเวลาเข้า-ออก / Activity โครงการ / รายงานลงเวลาทำงาน)
//   - รายชื่อมาจาก GET <หน้า>/filter-options (ชุดเดียวกับหน้ารายงานค่าเช่ารถ, backend กรองตามสิทธิ์แผนกแล้ว)
//   - ช่างแต่ละคนมี department_uid ใช้กรองตามแผนกที่เลือกฝั่งหน้าเว็บ
//   - ค่าที่เลือกเก็บเป็น technician uid (ว่าง = ทั้งหมดในแผนก)

export const formatTechnician = (tech) => [tech?.technician_code, tech?.name].filter(Boolean).join(" - ") || "-";

/** ช่างที่แสดงใน dropdown: เลือกแผนกแล้วเหลือเฉพาะช่างแผนกนั้น */
export const techniciansInDepartment = (technicians, departmentUid) =>
  departmentUid ? (technicians || []).filter((tech) => tech.department_uid === departmentUid) : technicians || [];

/** options + placeholder ของ Select · t = ฟังก์ชันแปลภาษา */
export const technicianSelectProps = (technicians, departmentUid, t) => {
  const scope = techniciansInDepartment(technicians, departmentUid);
  const empty = !!departmentUid && scope.length === 0;
  const allLabel = departmentUid ? t("mileage_all_in_department").replace("{count}", scope.length) : t("all");
  return {
    disabled: empty,
    placeholder: empty ? t("technician_filter_no_employee_in_department") : allLabel,
    options: empty
      ? [{ value: "", label: t("technician_filter_no_employee_in_department"), disabled: true }]
      : [{ value: "", label: allLabel }, ...scope.map((tech) => ({ ...tech, value: tech.uid, label: formatTechnician(tech) }))],
  };
};
